module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-force-rebook"
  }, [_c('ModalReveal', {
    attrs: {
      "sizing": "small"
    }
  }, [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Force Rebook")]), _c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("Force rebook on " + _vm._s(_vm.vehicle.brand) + " " + _vm._s(_vm.vehicle.model) + " " + _vm._s(_vm.vehicle.plate))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Driver")]), _c('selectize-driver', {
    on: {
      "optionSelected": _vm.setDriver
    }
  })], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Memo"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.memo),
      expression: "body.memo"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.memo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "memo", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("Start"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "format": 'yyyy-mm-dd hh:ii'
    },
    model: {
      value: (_vm.body.start),
      callback: function($$v) {
        _vm.$set(_vm.body, "start", $$v)
      },
      expression: "body.start"
    }
  })], 1)]), _c('div', {
    staticClass: "columns"
  }, [_c('label', [_vm._v("End"), _c('date-picker', {
    attrs: {
      "pickTime": true,
      "format": 'yyyy-mm-dd hh:ii'
    },
    model: {
      value: (_vm.body.end),
      callback: function($$v) {
        _vm.$set(_vm.body, "end", $$v)
      },
      expression: "body.end"
    }
  })], 1)])]), _c('ActionButton', {
    attrs: {
      "action": _vm.forceRebook
    }
  }, [_vm._v("Create New Booking")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3725f57e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/ForceRebook.vue
// module id = 2407
// module chunks = 1